import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import UiConfirmDialog from 'ui-components/ui-confirm-dialog/UiConfirmDialog';
import UiButton from 'ui-components/ui-button/UiButton';
import UiIcon from 'ui-components/ui-icon/UiIcon';
import { UiErrors } from 'components/error/Error';

export const UiTableDeleteRecordModal = ({
  title,
  loading,
  error,
  onOk,
  onCancel,
  open,
  dataTestId,
}) => {
  const { t } = useTranslation();
  return (
    <UiConfirmDialog
      open={open}
      actions={
        <>
          <UiButton
            variant='outlined'
            color='secondary'
            startIcon={<UiIcon icon='ri-delete-bin-7-line' color='#F16063' />}
            onClick={onOk}
            disabled={loading}
            loading={loading}
            data-testid={`${dataTestId}-ok`}
          >
            {t('common:removeIt')}
          </UiButton>
          <UiButton
            variant='text'
            onClick={onCancel}
            color='primary'
            disabled={loading}
            data-testid={`${dataTestId}-cancel`}
          >
            {t('common:cancel')}
          </UiButton>
        </>
      }
    >
      {t('support:removeConfirmText', { title })}
      {error && <UiErrors errors={error} />}
    </UiConfirmDialog>
  );
};

UiTableDeleteRecordModal.propTypes = {
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.object,
  open: PropTypes.bool,
  dataTestId: PropTypes.string,
  title: PropTypes.string,
};
